export default "__VITE_ASSET__ClVCMNU5__"